import { Controller } from '@hotwired/stimulus';
import { patch } from '@rails/request.js';
import Sortable, { AutoScroll } from 'sortablejs/modular/sortable.core.esm';

export default class extends Controller {
  static targets = ['column', 'count'];

  static classes = ['ghost'];

  static isAutoScrollMounted = false;

  initialize() {
    // Check if AutoScroll has already been mounted
    if (!this.constructor.isAutoScrollMounted) {
      Sortable.mount(new AutoScroll());
      this.constructor.isAutoScrollMounted = true;
    }
  }

  connect() {
    this.sortables = [];

    this.columnTargets.forEach((column) => {
      const sortable = new Sortable(column, {
        group: 'measures',
        animation: 150,
        draggable: '[data-measure-position-update-path]',
        forceAutoScrollFallback: true,
        scroll: true,
        scrollSensitivity: 200,
        scrollSpeed: 25,
        bubbleScroll: true,
        onStart: (event) => {
          event.item.addEventListener('click', this.preventClick, true);
        },
        onEnd: (event) => {
          event.item.removeEventListener('click', this.preventClick, true);
          this.handleDragEnd(event);
        },
        ghostClass: this.ghostClass,
      });

      this.sortables.push(sortable);
    });
  }

  disconnect() {
    this.sortables.forEach((sortable) => {
      sortable.destroy();
    });
    this.sortables = [];
  }

  preventClick(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  handleDragEnd(event) {
    const positionUpdatePath = event.item.dataset.measurePositionUpdatePath;
    const newStatus = event.to.dataset.status;
    const { newIndex } = event;

    if (event.from !== event.to) {
      this.updateCounts(event.from);
      this.updateCounts(event.to);
    }

    const formData = new FormData();
    formData.append('status', newStatus);
    formData.append('position', newIndex);

    patch(positionUpdatePath, {
      responseKind: 'turbo-stream',
      body: formData,
      credentials: 'same-origin',
    });
  }

  updateCounts(column) {
    const { status } = column.dataset;
    const countElement = this.countTargets.find(
      (element) => element.dataset.status === status,
    );
    if (countElement) {
      countElement.textContent = column.querySelectorAll(
        '[data-measure-position-update-path]',
      ).length;
    }
  }
}
